import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { DeprecatedIcon } from '@mentimeter/ragnar-visuals/slide-type-icons';

export function DeprecatedPresentation() {
  return (
    <Box
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <DeprecatedIcon size={100} />
      <Text mt={2} textAlign="center" color="text" fontSize={40}>
        This slide type is no longer supported
      </Text>
    </Box>
  );
}
